const relationshipToClaimant = {
	Mother: {
		name: "Mother",
		value: "Mother"
	},
	Father: {
		name: "Father",
		value: "Father"
	},
	Guardian: {
		name: "Guardian",
		value: "Guardian"
	}
};

const contactRelationshipToClaimant = {
	relationshipToClaimant,
	options: Object.values(relationshipToClaimant)
};

export default contactRelationshipToClaimant;